module.exports = "<p>{{ data.comentario }}</p>\n<h4><strong>{{ data.usuario }}</strong></h4>\n"